<template>
  <v-card class="dt-modal">
    <div class="dt-modal--header">{{ $t('email') }}</div>
    <div class="dt-modal--body">
      <div class="form-group">
        <TextField
          :id="'contact_group_emails_textarea'"
          textarea
          v-bind="textFieldConfig"
          v-model="emailsLocal"
          isModel
          :height="400"
        />
      </div>
      <v-layout row wrap>
        <v-flex md6>
          <v-layout row wrap>
            <v-flex md1 class="checkbox-container">
              <div class="dt-checkbox">
                <input
                  type="checkbox"
                  @click="e => onAddCommaCheckBoxChanged(e)"
                  :name="'cb_add_re_comma'"
                  :id="'cb_add_re_comma'"
                >
                <div class="checkmark"></div>
              </div>
            </v-flex>
            <v-flex md11>{{ $t('add_comma') }}</v-flex>
          </v-layout>
        </v-flex>
        <v-flex md6>
          <v-layout row wrap justify-end>
            <button class="dt-button v1" @click.stop="onCancel">{{$t('ok')}}</button>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import TextField from "@plugins/text-field/text-field";

export default {
  components: {
    TextField
  },
  props: ["emails"],
  data: function() {
    return {
      isCommaAdded: false,
      emailsLocal: "",
      textFieldConfig: {
        height: 142,
        showEditIconOnHover: false,
        box: true
      }
    };
  },
  watch: {
    emails: {
      immediate: true,
      handler: function(newValue, oldValue) {
        this.emailsLocal = newValue;
      }
    }
  },
  computed: {},
  methods: {
    onCancel: function() {
      this.$emit("cancelled");
    },
    onAddCommaCheckBoxChanged(e) {
      this.isCommaAdded = e.target.checked;
      if (this.isCommaAdded == true) {
        this.emailsLocal = this.emailsLocal.split("\n").join(",\n");
      } else {
        this.emailsLocal = this.emailsLocal.split(",\n").join("\n");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-container{
  padding: 5px 0;
}
</style>
